import { render, staticRenderFns } from "./InputComment.vue?vue&type=template&id=41dcba3a"
import script from "./InputComment.vue?vue&type=script&lang=js"
export * from "./InputComment.vue?vue&type=script&lang=js"
import style0 from "./InputComment.vue?vue&type=style&index=0&id=41dcba3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports